<template>
  <div class="flex gap-3">
    <div class="flex-1">
      <input 
        :value="displayName" 
        type="text" 
        class="w-full h-11 px-3 py-2 bg-slate-50 border border-slate-300 rounded-md text-slate-500"
        placeholder="Wybierz kategorię" 
        disabled
      />
    </div>
    <button 
      class="h-11 px-6 border border-slate-300 text-slate-700 bg-white rounded-md hover:border-blue-500 hover:text-blue-600 transition-colors font-medium" 
      type="button" 
      @click="openModal"
    >
      Wybierz
    </button>
  </div>
  
  <CategoryPickerModal 
    :show="showModal" 
    @close="closeModal" 
    @select="handleSelect" 
  />
</template>

<script setup lang="ts">
import { ref } from 'vue';
import CategoryPickerModal from './CategoryPickerModal.vue';

interface Category {
  id: number;
  name: string;
}

defineProps<{
  displayName: string;
}>();

const emit = defineEmits<{
  select: [category: Category];
}>();

const showModal = ref(false);

function openModal() {
  showModal.value = true;
}

function closeModal() {
  showModal.value = false;
}

function handleSelect(category: Category) {
  emit('select', category);
  closeModal();
}
</script>